<template>
  <div class="slider-videos">
    <span class="ico ico-next" @click="nextSlide">
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="20" cy="20" r="20" fill="white" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.3295 11.9545C15.7688 11.5152 16.4812 11.5152 16.9205 11.9545L23.6705 18.7045C24.1098 19.1438 24.1098 19.8562 23.6705 20.2955L16.9205 27.0455C16.4812 27.4848 15.7688 27.4848 15.3295 27.0455C14.8902 26.6062 14.8902 25.8938 15.3295 25.4545L21.284 19.5L15.3295 13.5455C14.8902 13.1062 14.8902 12.3938 15.3295 11.9545Z"
          fill="var(--theme-color)"
        />
      </svg>
    </span>
    <span class="ico ico-prev" @click="prevSlide">
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="20"
          cy="20"
          r="20"
          transform="rotate(-180 20 20)"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.6705 28.0455C24.2312 28.4848 23.5188 28.4848 23.0795 28.0455L16.3295 21.2955C15.8902 20.8562 15.8902 20.1438 16.3295 19.7045L23.0795 12.9545C23.5188 12.5152 24.2312 12.5152 24.6705 12.9545C25.1098 13.3938 25.1098 14.1062 24.6705 14.5455L18.716 20.5L24.6705 26.4545C25.1098 26.8938 25.1098 27.6062 24.6705 28.0455Z"
          fill="var(--theme-color)"
        />
      </svg>
    </span>
    <div class="slider">
      <swiper class="swiper" ref="swiper" :options="swiperOptionMoreVideo">
        <swiper-slide v-for="video in moreVideos" :key="video.id">
          <div class="slider-tutorial" @click="setCurrentVideo(video)">
            <img :src="video.thumbnail" alt="" />
            <div class="overlay-slider">
              <h3>{{ video.text }}</h3>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  name: "MoreVideos",
  props: ["moreVideos"],
  data() {
    return {
      swiperOptionMoreVideo: {
        spaceBetween: 30,
        slidesPerView: 3
      }
    };
  },
  methods: {
    nextSlide() {
      this.$refs.swiper.$swiper.slideNext();
      //console.log(this.$refs.swiper.$swiper.activeIndex);
    },
    prevSlide() {
      this.$refs.swiper.$swiper.slidePrev();
      //console.log(this.$refs.swiper.$swiper.activeIndex);
    },
    setCurrentVideo(video) {
      this.$emit("setCurrentVideo", video);
    }
  }
};
</script>

<style lang="scss" scoped>
.slider-videos {
  background-color: #fff;
  padding: 24px;
  position: relative;
  .ico {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    z-index: 2;
    cursor: pointer;
    border-radius: 50%;
    transition: all 0.2s linear;
    box-shadow: 0px 4px 6px -4px #444;

    &:hover {
      box-shadow: 0px 4px 4px #333;
    }
  }
  .ico-next {
    right: 12px;
  }
  .ico-prev {
    left: 12px;
  }
}
.slider-tutorial {
  position: relative;
  width: 100%;
  height: 158px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;

  img {
    width: 70%;
    object-fit: cover;
  }

  .overlay-slider {
    position: absolute;
    border-radius: 12px;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    h3 {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 32px;
      line-height: 44px;
      color: #ffffff;
    }
  }
}
</style>
